/* unplugin-vue-components disabled */import { render } from "./Layout4.vue.js?vue&type=template&id=0468adbb!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Layout4.vue?vue&type=template&id=0468adbb"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__